export default {"src":"/_next/static/media/google.2467a81d.svg","height":40,"width":40};